export default __webpack_public_path__ + "static/increased-wall-57224e52c1b3e01917eaefec28ddd7c2.jpeg";